import { Moon, Sun } from 'lucide-react'
import { useTheme } from '../../utils/theme'
import { useI18n } from '../../utils/i18n'
import { IconButton } from './IconButton'

export function ThemeToggle({ className = '' }) {
  const { theme, toggleTheme } = useTheme()
  const { t } = useI18n()
  const isDark = theme === 'dark'

  return (
    <IconButton onClick={toggleTheme} className={className} title={isDark ? t('switchToLight') : t('switchToDark')} aria-label="toggle-theme">
      {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
    </IconButton>
  )
}
